import React, { useEffect } from 'react';
import { StickyAlertBar } from './components/StickyAlertBar';
import { Hero } from './components/Hero';
import { EmpathySection } from './components/EmpathySection';
import { EmotionalValidation } from './components/EmotionalValidation';
import { BenefitsGrid } from './components/BenefitsGrid';
import { SocialProof } from './components/SocialProof';
import { ValueStack } from './components/ValueStack';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQ } from './components/FAQ';
import { FinalClose } from './components/FinalClose';
import { Footer } from './components/Footer';
import { initMetaPixel, META_PIXEL_ID } from './lib/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen flex flex-col bg-white font-sans text-dark" data-id="element-0">
      {/* Meta Pixel <noscript> fallback */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" />
      </noscript>

      <StickyAlertBar data-id="element-3" />
      <main data-id="element-4">
        <Hero data-id="element-5" />
        <EmpathySection data-id="element-6" />
        <EmotionalValidation data-id="element-7" />
        <BenefitsGrid data-id="element-8" />
        <SocialProof data-id="element-9" />
        <ValueStack data-id="element-10" />
        <GuaranteeSection data-id="element-11" />
        <FAQ data-id="element-12" />
        <FinalClose data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
    </div>;
}